import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import TemplateNoneBtn from "../../../page/ThirdScreen/qrSettings/qrTemplates/templateNoneBtn";
import SavedTemplate from "../../../page/ThirdScreen/qrSettings/qrTemplates/savedTemplate";
import { getAllTemplates } from "../../../redux/requests";
import useFrames from "../../../hooks/useFrames";

const ImportFromCsv = () => {
  const templates = useSelector((state) => state.qrTemplates.templates);
  const activeQrTemplate = useSelector(
    (state) => state.qrTemplates.activeQrTemplate
  );

  const dispatch = useDispatch();
  const { frameConfigs } = useFrames();

  useEffect(() => {
    dispatch(getAllTemplates({ frameConfigs }));
  }, []);

  useEffect(() => {
    const templateInput = document.querySelector(
      "#entry_csv_add_form_template"
    );
    if (templateInput) {
      templateInput.value = activeQrTemplate;
    }
  }, [activeQrTemplate]);

  return (
    <div className="mb-3">
      <Row className="g-2 g-lg-3">
        <TemplateNoneBtn />
        {templates.map((template) => (
          <SavedTemplate
            key={template.id}
            template={template}
            qrData="https://me-qr.com/"
          />
        ))}
      </Row>
    </div>
  );
};

export default ImportFromCsv;
